import {
  animate,
  AnimationBuilder,
  AnimationPlayer,
  style
} from '@angular/animations';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CookieHelper } from '../../common/cookie-helper';
import { CountryLanguageHelper } from '../../common/country-language-helper';
import { CommonService } from '../../services/common.service';
import { FlyoutLangselectorComponent } from '../flyout-langselector/flyout-langselector.component';

declare let delta: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ng-lang-select-confirmation',
  templateUrl: 'flyout-lang-select-confirmation.component.html',
  providers: [CookieHelper]
})
export class FlyoutLangSelectConfirmationComponent implements AfterViewInit {
  @ViewChild('dialog') dialog: any;
  countrycode: string;
  languageCode: string;
  secondaryLanguageCode: string;
  country: any;
  primaryLanguage: any;
  secondaryLanguage: any;
  content1 = '';
  content2 = '';
  flyoutLanguageSelector: any;
  countryLanguageContent: any;
  private player: AnimationPlayer;
  private animationTime = '300ms';

  constructor(
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    public cookieHelper: CookieHelper,
    public countryLanguageHelper: CountryLanguageHelper,
    private _builder: AnimationBuilder,
    private srv: CommonService,
    private elementRef: ElementRef
  ) {}

  ngAfterViewInit() {
    const langConfContainer = this.elementRef.nativeElement.querySelector(
      '.lang-selct-confirm-modal-content'
    );
    if (langConfContainer) {
      langConfContainer.focus();
    }
    this.srv.trapFocusInsideModal(this.elementRef);
  }

  setCLSData(countrycode, languageCode, secondaryLanguageCode) {
    this.countrycode = countrycode;
    this.languageCode = languageCode;
    this.secondaryLanguageCode = secondaryLanguageCode;
    if (this.countrycode && this.languageCode && this.secondaryLanguageCode) {
      this.country = this.countryLanguageHelper.getCountryForCountryCode(
        this.countrycode
      );
      this.primaryLanguage =
        this.countryLanguageHelper.getLangaugeForLanguageCode(
          this.countrycode,
          languageCode
        );
      this.secondaryLanguage =
        this.countryLanguageHelper.getLangaugeForLanguageCode(
          this.countrycode,
          secondaryLanguageCode
        );
      this.content1 =
        this.countryLanguageHelper.getTranslatedTextForLanguageCode(
          this.primaryLanguage.languageCode,
          'welcome-delta'
        );
      this.content2 =
        this.countryLanguageHelper.getTranslatedTextForLanguageCode(
          this.secondaryLanguage.languageCode,
          'welcome-delta'
        );
    }
  }

  setPrefCookieOnSelect(isPrimarySelected) {
    this.countryLanguageHelper.setShowConfirmationModal(false);
    if (isPrimarySelected) {
      this.setPrefCookieOnLangSelect(this.countrycode, this.languageCode);
    } else {
      this.setPrefCookieOnLangSelect(
        this.countrycode,
        this.secondaryLanguageCode
      );
      this.countryLanguageHelper.redirectToTranslatedSites(
        this.countrycode,
        this.secondaryLanguageCode
      );
    }
    this.bsModalRef.hide();
  }

  setPrefCookieOnLangSelect(countrycode, languageCode) {
    const prefvalue = languageCode + '-' + countrycode;
    this.countryLanguageHelper.setPrefCookie(prefvalue);
    this.countryLanguageHelper.setPreferedLanguages(prefvalue);
  }

  openCLS() {
    this.bsModalRef.hide();
    let obj;
    const config = {
      backdrop: true,
      animated: false,
      keyboard: false
    };
    obj = Object.assign({}, config, { class: 'lang-modal' });
    this.flyoutLanguageSelector = this.modalService.show(
      FlyoutLangselectorComponent,
      obj
    );
    this.animateCLSModal();
    this.flyoutLanguageSelector.content.countryLanguageContent =
      this.countryLanguageContent;
    this.flyoutLanguageSelector.content.dialog.nativeElement.focus();
    const htmlRoot = document.getElementsByTagName('html')[0];
    if (!(htmlRoot.className.indexOf('no-scroll') >= 0)) {
      htmlRoot.className += ' no-scroll';
    }
  }

  animateCLSModal() {
    if (this.player) {
      this.player.destroy();
    }
    const factory = this._builder.build([
      style({ visibility: 'visible', opacity: 0 }),
      animate(this.animationTime + ' ease-out', style({ opacity: 1 }))
    ]);
    this.player = factory.create(
      document.getElementsByClassName('lang-modal-content')[0],
      {}
    );
    this.player.play();
  }
}
